import React from 'react';

const ModalBody = ({ children }) => {
  return <div className="relative p-6 flex-auto">{children}</div>;
};

export default ModalBody;
